import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { ButtonOutline, ButtonRow } from "../components/button.tsx";
import ModalBase2 from "./modal_base_2.tsx";
import { ViewBase2Inner } from "../views/view_base_2.tsx";

export default function ModalBase1() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const push_modal = useStore((state) => state.push_modal_non_close);

  return (<Panel >
            <ViewBase2Inner/>
            <ButtonRow>
              <ButtonOutline label='zurück' onClick={()=>{
                pop_modal();
              }}/>
              <Button label='weiter' onClick={()=>{
                push_modal(<ModalBase2/>);
              }}/>
            </ButtonRow>
         </Panel>)
}